var map = {
	"./GraduationCeremonies1.jpeg": 4949,
	"./GraduationCeremonies10.jpeg": 2283,
	"./GraduationCeremonies2.jpeg": 1028,
	"./GraduationCeremonies3.jpeg": 4363,
	"./GraduationCeremonies4.jpeg": 9370,
	"./GraduationCeremonies5.jpeg": 8913,
	"./GraduationCeremonies6.jpeg": 1808,
	"./GraduationCeremonies7.jpeg": 2727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3578;